import { connect } from 'react-redux';
import { closePanelByType, openPanel } from '../../../../shared/actions/sidebar';
import { identificationType, panelGroup, panelType } from '../../../../shared/constants';
import { isPanelOpen, shouldRestoreOpenerFocus } from '../../../../shared/actions/sidebarUtils';
import EnhancementButton from '../enhancementButton/enhancementButton';

const canShowByIdType = {
  [identificationType.pii]: data => (data && data.citingArticles && data.citingArticles.length > 0),
  [identificationType.doi]: data => (data && data.length > 0),
  [identificationType.document]: () => false,
};

const mapStateToProps = (state) => {
  const { citingArticles, idType, sidebar } = state;
  const canShowCalculator = canShowByIdType[idType];
  const canShow = canShowCalculator && canShowCalculator(citingArticles.data);

  return {
    active: sidebar.isOpen && isPanelOpen(state, panelGroup.enhancements, panelType.citedBy),
    canShow,
    heading: 'Cited by',
    attributeId: 'citing-articles',
    restoreFocus: shouldRestoreOpenerFocus(state, panelGroup.enhancements, panelType.citedBy),
  };
};

const mapDispatchToProps = dispatch => ({
  closeSidePanel: () => dispatch(closePanelByType(panelGroup.enhancements, panelType.citedBy)),
  openSidePanel: () => dispatch(openPanel(panelGroup.enhancements, panelType.citedBy)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnhancementButton);
